import vtTabbedAppTemplate from './vt-tabbed-app-template.vue'
import vtTabbedApp from './vt-tabbed-app.vue'
export const vtAppComponents = {
  vtTabbedAppTemplate,
  vtTabbedApp,
}